import { cn } from '@/client/lib/utils';
import { PersonOverviewTab } from './PersonOverviewTab';
import { PersonProjectsTab } from './PersonProjectsTab';
import { PersonTimeTab } from './PersonTimeTab';
import type { RouterOutputs } from '@/client/utils/trpc';

type Employee = RouterOutputs['employees']['list'][number];

const TABS = ['overview', 'projects', 'time'] as const;
type Tab = (typeof TABS)[number];

const TAB_LABELS: Record<Tab, string> = {
  overview: 'Overview',
  projects: 'Projects',
  time: 'Time',
};

interface PersonTabsProps {
  person: Employee;
  activeTab: string;
  onTabChange: (tab: Tab) => void;
}

export function PersonTabs({ person, activeTab, onTabChange }: PersonTabsProps) {
  const tab: Tab = TABS.includes(activeTab as Tab) ? (activeTab as Tab) : 'overview';

  return (
    <div>
      <div className="mb-5 flex gap-1 border-b">
        {TABS.map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => onTabChange(t)}
            className={cn(
              '-mb-px border-b-2 px-4 py-2 text-sm font-medium transition-colors',
              tab === t
                ? 'border-foreground text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground',
            )}
          >
            {TAB_LABELS[t]}
          </button>
        ))}
      </div>
      {tab === 'overview' && <PersonOverviewTab person={person} />}
      {tab === 'projects' && <PersonProjectsTab person={person} />}
      {tab === 'time' && <PersonTimeTab person={person} />}
    </div>
  );
}
